import { combineReducers } from 'redux';
import { shopRequest } from './shopRequest'
import { productRequest } from './productRequest'
import { purchaseRequest } from './purchaseRequest'
// import { inventoryRequest } from './inventoryRequest'
import { saleRequest } from './saleRequest'
import { clientRequest } from './clientRequest'
import { devisRequest } from './devisRequest'
import { photoRequest } from './photoRequest'
import { reportRequest } from './reportRequest'
import { paymentRequest } from './paymentRequest'
import { prospectRequest } from './prospectRequest'
import { subscriptionRequest } from './subscriptionRequest'
import { zoneRequest } from './zoneRequest'
import { spendingRequest } from './spendingRequest'
import { returnRequest } from './returnRequest'
import { returnSaleRequest } from './returnSaleRequest'
import { commercialReaRequest } from './commercialReaRequest'
import { commercialStockRequest } from './commercialStockRequest'
import { commercialReturnRequest } from './commercialReturnRequest'
import { orderRequest } from './orderRequest'
import { arrivageRequest } from './arrivageRequest';
import { demandRequest } from './demandRequest';
import { paygClientRequest } from './paygClientRequest';
import { recoveryRequest } from './recoveryRequest';
import { resaRequest } from './resaRequest';
import { resaDemandRequest } from './resaDemandRequest';
import { installRequest } from './installRequest';
import { saleCreditRequest } from './saleCreditRequest';
import { societyRequest } from './societyRequest';

export const initialState = {
    products:{
        fetching:false,
        fetched: false,
        error:null,
    },
    shops:{
        fetching:false,
        fetched: false,
        error:null,
    },
    stocks:{
        fetching:false,
        fetched: false,
        error:null,
    },
    sales:{
        fetching:false,
        fetched: false,
        error:null,
    },
    clients:{
        fetching:false,
        fetched: false,
        error:null,
    },
    purchases:{
        fetching:false,
        fetched: false,
        error:null,
    },
    photo:{
        fetching:false,
        fetched: false,
        error:null,
    },
    report:{
        fetching:false,
        fetched: false,
        error:null,
    },
    payment:{
        fetching:false,
        fetched: false,
        error:null,
    },
    prospect:{
        fetching:false,
        fetched: false,
        error:null,
    },
    devis:{
        fetching:false,
        fetched: false,
        error:null,
    },
    zones:{
        fetching:false,
        fetched: false,
        error:null,
    },
    spendings:{
        fetching:false,
        fetched: false,
        error:null,
    },
    returns:{
        fetching:false,
        fetched: false,
        error:null,
    },
    returnSales:{
        fetching:false,
        fetched: false,
        error:null,
    },
    commercialReas:{
        fetching:false,
        fetched: false,
        error:null,
    },
    commercialStocks:{
        fetching:false,
        fetched: false,
        error:null,
    },
    commercialReturns:{
        fetching:false,
        fetched: false,
        error:null,
    },
    orders:{
        fetching:false,
        fetched: false,
        error:null,
    },
    arrivages:{
        fetching:false,
        fetched: false,
        error:null,
    },
    demands:{
        fetching:false,
        fetched: false,
        error:null,
    },
    paygClients:{
        fetching:false,
        fetched: false,
        error:null,
    },
    recovery:{
        fetching:false,
        fetched: false,
        error:null,
    },
    resas:{
        fetching:false,
        fetched: false,
        error:null,
    },
    resaDemands:{
        fetching:false,
        fetched: false,
        error:null,
    },
    installs:{
        fetching:false,
        fetched: false,
        error:null,
    },
    sale_credits:{
        fetching:false,
        fetched: false,
        error:null,
    },
    society:{
        fetching:false,
        fetched: false,
        error:null,
    },
};
export default combineReducers({
    products : productRequest,
    purchases : purchaseRequest,
    shops : shopRequest,
    stocks : initialState.stocks,
    sales : saleRequest,
    clients : clientRequest,
    devis : devisRequest,
    photos : photoRequest,
    reports : reportRequest,
    payments : paymentRequest,
    prospects : prospectRequest,
    subscriptions : subscriptionRequest,
    zones : zoneRequest,
    spendings : spendingRequest,
    returns : returnRequest,
    returnSales : returnSaleRequest,
    commercialReas : commercialReaRequest,
    commercialStocks : commercialStockRequest,
    commercialReturns : commercialReturnRequest,
    orders : orderRequest,
    arrivages  : arrivageRequest,
    demands: demandRequest,
    paygClients: paygClientRequest,
    recovery: recoveryRequest,
    resas: resaRequest,
    resaDemands: resaDemandRequest,
    installs: installRequest,
    credits: saleCreditRequest,
    society: societyRequest,
});